import React, { useEffect, useState } from 'react'
import AddSoldRecipesModal from './AddSoldRecipesModal'
import { WASTAGE_COPY } from 'src/constants/wastage'

export const WastedRecipesMenuLabel = () => (
  <span data-testid='stock-add-wasted-recipes'>
    {WASTAGE_COPY.wastedRecipesAction}
  </span>
)

const AddWastedRecipesModal = props => {
  const [reason, setReason] = useState('')

  useEffect(() => {
    if (!props.visible) setReason('')
  }, [props.visible])

  return (
    <AddSoldRecipesModal
      {...props}
      existingSoldRecipes={[]}
      modalTitle={WASTAGE_COPY.title}
      okText={WASTAGE_COPY.record}
      quantityLabel='Qty Wasted'
      usageField='wastage'
      previewTitle='On the ingredient lines'
      previewEmptyText='Enter a quantity to see which ingredient lines this dish lands on.'
      previewErrorText='Unable to calculate wastage preview. Please check your recipe data.'
      usageQtyColumnLabel='Wastage Qty'
      helperDescription={WASTAGE_COPY.wastedRecipesSameList}
      previewNote={WASTAGE_COPY.wastedRecipesSameList}
      showReason
      reason={reason}
      onReason={setReason}
    />
  )
}

export default AddWastedRecipesModal
